export const FRONTEND_URL = process.env.VUE_APP_FRONTEND_URL
export const UPLOADER_URL = process.env.VUE_APP_UPLOADER_URL
export const MESSAGING_URL = process.env.VUE_APP_MESSAGING_URL
export const BILLING_URL = process.env.VUE_APP_BILLING_URL
export const PROJECT_URL = process.env.VUE_APP_PROJECT_URL
export const TILE_URL = process.env.VUE_APP_TILE_URL
export const FLIGHT_PROVIDER_URL = process.env.VUE_APP_FLIGHT_PROVIDER_URL
export const LOGGING_URL = process.env.VUE_APP_LOGGING_URL
export const AUTH_URL = process.env.VUE_APP_AUTH_URL
export const REDIRECT_URI = process.env.VUE_APP_REDIRECT_URI
export const CLIENT_ID = process.env.VUE_APP_CLIENT_ID
export const AWS_KEY = process.env.VUE_APP_AWS_KEY
export const AWS_BUCKET = process.env.VUE_APP_AWS_BUCKET
export const NEWS_URL = process.env.VUE_APP_NEWS_URL
export const ENVIRONMENT = process.env.VUE_APP_ENVIRONMENT
